hylo-data {
  display: contents;
  height: 0px;
  width: 0px;
}